import { LocationAttributes } from '../../../../Types/Location'
import { FormSequence } from '../formSequence'
import isBriefUsingGuestSession from '../isBriefUsingGuestSession'
import {
  requiredGuestAttrs,
  requiredLocationAttrs as requiredBizLocationAttrs,
  requiredTimingAttrs,
} from '../Biz/sequence'

export const requiredLocationAttrs: Array<keyof LocationAttributes> = [
  ...requiredBizLocationAttrs,
  'leadFeedCity',
]

export const LEAD_FEED_FORM_SEQUENCE: FormSequence = [
  {
    path: 'location',
    isStepComplete: (brief) => requiredLocationAttrs.every((attr) => !!brief[attr]),
    skipStep: (brief) => typeof brief.hostId === 'string' && typeof brief.spaceId === 'string',
  },
  {
    path: 'type',
    isStepComplete: (brief) => !!brief.collectionName && !!brief.collection,
  },
  {
    path: 'guests',
    isStepComplete: (brief) => brief.capacities !== undefined,
  },
  {
    path: 'style',
    isStepComplete: () => true,
  },
  {
    path: 'layout',
    isStepComplete: (brief) => !!brief.layouts,
  },
  {
    path: 'timings',
    isStepComplete: (brief) => requiredTimingAttrs.every((attr) => !!brief[attr]),
  },
  {
    path: 'flexible',
    isStepComplete: (brief) => brief.flexibleDates !== undefined,
  },
  {
    path: 'extras',
    isStepComplete: () => true,
  },
  {
    path: 'budget',
    isStepComplete: (brief) => !!brief.budget,
  },
  {
    path: 'name',
    isStepComplete: (brief) => !!brief.eventName,
  },
  {
    path: 'email',
    isStepComplete: (brief) =>
      !!brief.guest?.email &&
      (brief.userId !== undefined ||
        !!brief.guest?.unambiguousOrigin ||
        brief.guest?.country !== undefined),
    skipStep: isBriefUsingGuestSession,
  },
  {
    path: 'user',
    isStepComplete: ({ guest }) => !!guest && requiredGuestAttrs.every((attr) => !!guest[attr]),
    skipStep: (brief) => !!brief.userId,
  },
  {
    path: 'else',
    isStepComplete: () => true,
  },
]

export default LEAD_FEED_FORM_SEQUENCE
